import './chart_view.js.coffee';# Added by Script 
import './ticket_count_chart_view.js.coffee'
Namespace 'CustomerVisualMode.Charts'

class CustomerVisualMode.Charts.WomCountChartView extends CustomerVisualMode.Charts.ChartView
  template: JST['backbone/templates/customer_visual_mode/charts/wom_count_chart']
  className: 'grid-item full-width-chart'
  @NAME: 'wom_metrics'

  initialize: ({widget, data, session, isReadOnly, isResponsive}) ->
    title = I18n.t('customer_visual_mode.charts.wom_count_metrics.title')
    description = I18n.t('customer_visual_mode.charts.wom_count_metrics.title')
    super({widget, title, description, data, session, isReadOnly, isResponsive})

  render: ->
    super()
    @$el.find('.chart').html @template
    @_womCountCardViews().forEach (view) =>
      @$('.wom-count-chart').append(
        view.render().el
      )
    @

  _womCountCardViews: ->
    [
      @_avgFirstHumanAssignationSinceCreationMetricView()
      @_avgFirstHumanCloseSinceCreationMetricView()
      @_avgFirstHumanCloseSinceFirstHumanAssignationMetricView()
      @_avgLastCloseSinceCreationMetricView()
    ]

  _avgFirstHumanAssignationSinceCreationMetricView: ->
    @avgFirstHumanAssignationSinceCreationMetricView ||= new CustomerVisualMode.Charts.TicketCountCardView(
      count: @_formatSeconds(@data.average_first_human_assignation_since_creation)
      clickable: false
      title: I18n.t('customer_visual_mode.charts.wom_count_metrics.average_first_human_assignation_since_creation')
      iconClass: 'fa fa-clock-o'
    )

  _avgFirstHumanCloseSinceCreationMetricView: ->
    @avgFirstHumanCloseSinceCreationMetricView ||= new CustomerVisualMode.Charts.TicketCountCardView(
      count: @_formatSeconds(@data.average_first_human_close_since_creation)
      clickable: false
      title: I18n.t('customer_visual_mode.charts.wom_count_metrics.average_first_human_close_since_creation')
      iconClass: 'fa fa-clock-o'
    )

  _avgFirstHumanCloseSinceFirstHumanAssignationMetricView: ->
    @avgFirstHumanCloseSinceFirstHumanAssignationMetricView ||= new CustomerVisualMode.Charts.TicketCountCardView(
      count: @_formatSeconds(@data.average_first_human_close_since_first_human_assignation)
      clickable: false
      title: I18n.t('customer_visual_mode.charts.wom_count_metrics.average_first_human_close_since_first_human_assignation')
      iconClass: 'fa fa-clock-o'
    )

  _avgLastCloseSinceCreationMetricView: ->
    @avgLastCloseSinceCreationMetricView ||= new CustomerVisualMode.Charts.TicketCountCardView(
      count: @_formatSeconds(@data.average_last_close_since_creation)
      clickable: false
      title: I18n.t('customer_visual_mode.charts.wom_count_metrics.average_last_close_since_creation')
      iconClass: 'fa fa-clock-o'
    )

  _formatSeconds: (secondsToFormat) ->
    duration = moment.duration(parseInt(secondsToFormat, 10), 'seconds')
    hours = parseInt(duration.asHours(), 10)
    minutes = parseInt(duration.minutes(), 10)
    seconds = parseInt(duration.seconds(), 10)
    "#{@_prependDigit(hours)}:#{@_prependDigit(minutes)}:#{@_prependDigit(seconds)}"

  _prependDigit: (number) ->
    "#{number}".padStart(2, '0')
